{
  "ai": {
    "title": "AI assistant",
    "saved": "Settings saved",
    "loadError": "Unable to load AI assistant settings",
    "dirty": "You have unsaved changes",
    "save": "Save settings",
    "tabs": {
      "general": "General",
      "business": "Business information",
      "payment": "Payment",
      "usage": "Usage"
    },
    "general": {
      "enabled": "Enable AI assistant",
      "enabledHelp": "When enabled, the bot automatically replies to customers on selected channels",
      "authority": "Bot permissions",
      "authorityHelp": "Choose whether the bot can create orders itself or must wait for approval",
      "channels": "Channels the AI answers",
      "customerConfirm": "Customer confirms",
      "adminApprove": "Admin approves",
      "tone": "Reply tone",
      "friendly": "Friendly",
      "formal": "Formal",
      "playful": "Playful",
      "replyLanguage": "Reply language",
      "automaticLanguage": "Automatic (customer's language)",
      "thai": "Thai",
      "english": "English",
      "customNotes": "Tone notes",
      "customNotesHelp": "How the AI words its replies, for example addressing customers as \"Dear customer\". Set delivery fees, free-shipping rules and shop details on the Delivery page and the Business information tab.",
      "customNotesPlaceholder": "For example, address customers as \"Dear customer\""
    },
    "business": {
      "description": "Business description",
      "descriptionHelp": "The bot uses this information to introduce your store and products",
      "descriptionPlaceholder": "For example, a women's fashion store shipping nationwide",
      "faq": "Frequently asked questions (FAQ)",
      "questionRequired": "Enter a question",
      "questionPlaceholder": "Question, e.g. How long does delivery take?",
      "answerRequired": "Enter an answer",
      "answerPlaceholder": "Answer, e.g. Delivery takes 2–3 business days",
      "remove": "Remove",
      "addQuestion": "Add question",
      "shippingPolicy": "Shipping policy",
      "shippingPlaceholder": "For example, free shipping over THB 500; ships within 2–3 days",
      "returnPolicy": "Return policy",
      "returnPlaceholder": "For example, damaged items can be returned within 7 days"
    },
    "channels": {
      "intro": "Select the channels where the bot should automatically reply to customers",
      "notConnected": "Not connected",
      "connectHere": "Connect here",
      "connectFirst": "Connect this channel before enabling the bot"
    },
    "payment": {
      "bankAccounts": "Bank accounts",
      "bankRequired": "Enter a bank name",
      "bankPlaceholder": "Bank name, e.g. SCB",
      "accountNumberRequired": "Enter an account number",
      "accountNumberPlaceholder": "Account number",
      "accountNameRequired": "Enter an account name",
      "accountNamePlaceholder": "Account name",
      "remove": "Remove",
      "addAccount": "Add account",
      "promptPayHelp": "Upload a QR image for the bot to send to customers at checkout",
      "promptPayQrAlt": "PromptPay QR code",
      "instructions": "Payment instructions",
      "instructionsPlaceholder": "For example, transfer the payment and attach the slip in chat"
    },
    "upload": {
      "imageOnly": "Only image files are supported (JPEG, PNG, WebP)",
      "tooLarge": "The file must be no larger than 1 MB",
      "failed": "Unable to upload the QR code. Try again.",
      "uploaded": "Uploaded",
      "remove": "Remove image",
      "replace": "Replace image",
      "upload": "Upload PromptPay QR"
    },
    "usage": {
      "loadError": "Unable to load usage data",
      "today": "Today",
      "used": "Used",
      "limit": "Limit",
      "remaining": "Remaining",
      "tokens": "tokens",
      "recent": "Last 7 days"
    },
    "loadFallback": "Unable to load AI settings",
    "saveFallback": "Unable to save AI settings",
    "leave": {
      "title": "Unsaved changes",
      "body": "If you leave this page now, changes you haven't saved are lost, including turning the AI assistant on or off.",
      "confirm": "Leave without saving",
      "cancel": "Stay on this page"
    }
  },
  "delivery": {
    "title": "Delivery",
    "saved": "Delivery settings saved",
    "loadError": "Unable to load delivery settings",
    "fee": "Delivery fee (THB)",
    "feeHelp": "Charged once per order. Enter 0 for free delivery.",
    "feePlaceholder": "For example, 50",
    "freeOver": "Free delivery for orders over (THB)",
    "freeOverHelp": "Leave blank if there is no free-delivery promotion",
    "freeOverPlaceholder": "For example, 500",
    "dirty": "You have unsaved changes",
    "save": "Save settings",
    "loadFallback": "Unable to load settings",
    "saveFallback": "Unable to save settings"
  }
}
